import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

// 站点数量统计
// export const SiteStat = params => {
export const MessageUnread = params => {
  return request('get', `${baseUrl}/api/auth/home/message/unread`, params);
};

// 消息中心左侧通知分类查询接口
export const getCategoryList = data => {
  return request('GET', `${baseUrl}/api/auth/sys/message/category/list`, data);
};

// 清理未读
export const changeunread = data => {
  return request('POST', `${baseUrl}/api/auth/sys/message/category/changeunread`, data);
};

// 分页查询 系统通知
export const getSysmsg = data => {
  return request('GET', `${baseUrl}/api/auth/sys/message/page/sysmsg`, data);
};

// 分页查询 非系统通知
export const getDevmsg = data => {
  return request('GET', `${baseUrl}/api/auth/sys/message/page/devmsg`, data);
};

// 维护消息手工处理 单条
export const handleMtone = data => {
  return request('POST', `${baseUrl}/api/auth/sys/message/handle/mtone`, data);
};

// 维护消息手工处理 多条
export const handleSelected = data => {
  return request('POST', `${baseUrl}/api/auth/sys/message/handle/selected`, data);
};

// 维护消息手工处理 全部
export const handleMtall = data => {
  return request('POST', `${baseUrl}/api/auth/sys/message/handle/mtall`, data);
};

// 消息中心搜索
export const getSearch = data => {
  return request('GET', `${baseUrl}/api/auth/sys/message/search`, data);
};

// 获取消息管理
export const manageGet = data => {
  return request('get', `${baseUrl}/api/auth/sys/message/manage/get`, data);
};
// 设置消息管理
export const manageSet = data => {
  return request('POST', `${baseUrl}/api/auth/sys/message/manage/set`, data);
};

// 重设消息管理
export const manageReset = data => {
  return request('POST', `${baseUrl}/api/auth/sys/message/manage/reset`, data);
};

// 获取未处理消息的数量
export const unhandleNum = data => {
  return request('get', `${baseUrl}/api/auth/sys/message/unhandle/num`, data);
};

// 清除特定分类的消息为已读
export const clearCategoryUnread = data => {
  return request('POST', `${baseUrl}/api/auth/sys/message/category/clearunread`, data);
};
